import React, { FC } from 'react'

import { IconStudentProps } from './IconStudent.types'
import * as Styled from './styles/IconStudent.style'

import { nonThemeableRules } from '../../ruleSet'

const IconStudent: FC<IconStudentProps> = ({
  size = nonThemeableRules.defaultSize as number as IconStudentProps['size'],
  isResponsive = false,
}: IconStudentProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive}>
      <svg fill='none' viewBox='0 0 48 48' xmlns='http://www.w3.org/2000/svg'>
        <path
          d='M21.878 7.385c1.185-.602 3.11-.602 4.297 0l17.118 9.145c1.185.6 1.185 1.553 0 2.153l-17.098 9.882c-1.185.6-3.102.6-4.29 0L4.708 19.133c-1.185-.6-1.185-1.55 0-2.153l17.17-9.595Z'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M37 22.323v11.035c0 1.072-.175 1.187-1.148 2.055-.972.867-5.874 5.52-11.852 5.52-5.977 0-11.018-4.683-11.915-5.52-.898-.838-1.085-.983-1.085-2.055'
          stroke='#fff'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
        <path
          d='M11 40.932V23.295c0-.395.273-.823.873-1.123l9-5.152'
          stroke='#EA1A1A'
          strokeLinecap='round'
          strokeLinejoin='round'
          strokeWidth='2'
        />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconStudent
